module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAN9JREFUSEvt07EKwjAQBuA7p4Kjq6NT38cUJS20o0+RZyk3+UBObm5ubg4hkQyFDkqTu2IFE+iU0i/57y/CQgsXciHDX0s+R/3bURtjVsYYJzll8oz7vt8jYmWt1W3bPrl4MhwgIjo759ZFURyVUg8OzoIH3Hu/8d4fmqa5p+JseHTzrbW26rruloKL4BG+Q0RV1/U1FhfDAw4AJQAorfUlBhfDoWipaDiYCOaiIliCsmEpyoKJ6AQA4Yku0ruysWZMRGVsez81nAXH/C5T72R4KqHZ9nPUs0U59aH/i/oFmhBUH8cnbesAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/jt.png
// module id = wUsx
// module chunks = 1